import { useCallback, useEffect, useRef, useState } from "react";
import { ChatListItem, InfoType, MessageItem, PromptsItem } from "components/ai-chat copy/types";

const Tabs = ["All", "system", "favorite", "public", "private"];

export default function useAIChatModel() {
  const [open, setOpen] = useState(false);
  const [chatlist, setChatlist] = useState<ChatListItem[]>([]);
  const [selectedKey, setSelectKey] = useState<string | null>(null);
  const [promptsOpen, setPromptsOpen] = useState(false);
  const [promptConfig, setPromptConfig] = useState({
    state: "close" as "close" | "New" | "Edit" | "View",
    favorite: true,
    promptContent: "",
    promptDescription: "",
    promptIcon: "lightbulb",
    promptTitle: "",
    promptType: "personal",
    promptVisibility: "public",
    id: null as string | null,
  });
  const [fullScreen, setFullScreen] = useState(false);
  const [drawerWidth, setDrawerWidth] = useState("680px");
  const [model, setModel] = useState<string | null>(null);
  const [draftIsMcpService, setDraftIsMcpService] = useState(false);
  const [topicServiceModes, setTopicServiceModes] = useState<Record<string, boolean>>({});
  const [inputDisable, setInputDisable] = useState<string[]>([]); // 如果数组内有chatId，则表示该chatId的输入框禁用
  const [accountDialogConfig, setAccountDialogConfig] = useState<{
    open: boolean;
    promptData?: any;
  }>({
    open: false,
  });
  const [currentAccountTags, setCurrentAccountTags] = useState<InfoType[]>([]);
  const [unsendMessages, setUnsendMessages] = useState<MessageItem[]>([]); // 用于存放首次发送消息时loaded的account数据
  const previousSelectedKeyRef = useRef<string | null>(selectedKey);
  const [searchPromptList, setSearchPromptList] = useState<any[]>([]);
  const [prompts, setPrompts] = useState<PromptsItem[]>(
    Tabs.map((type) => ({
      type,
      list: [],
      hasMore: true,
      nextpage: 0,
    }))
  );
  // hasMore & current for chatlist
  const [hasMore, setHasMore] = useState(true);
  const [current, setCurrent] = useState(0);
  const isMcpService = selectedKey ? (topicServiceModes[selectedKey] ?? false) : draftIsMcpService;
  const setIsMcpService = useCallback(
    (value: boolean, topicId: string | null = selectedKey) => {
      if (!topicId) {
        setDraftIsMcpService(value);
        return;
      }

      setTopicServiceModes((prev) => ({
        ...prev,
        [topicId]: value,
      }));
    },
    [selectedKey]
  );

  useEffect(() => {
    if (!fullScreen) {
      setPromptsOpen(false);
      setPromptConfig({
        state: "close",
        favorite: true,
        promptContent: "",
        promptDescription: "",
        promptIcon: "lightbulb",
        promptTitle: "",
        promptType: "personal",
        promptVisibility: "public",
        id: null,
      });
    }
  }, [fullScreen]);

  useEffect(() => {
    const previousSelectedKey = previousSelectedKeyRef.current;

    if (previousSelectedKey && !selectedKey) {
      setCurrentAccountTags([]);
      setUnsendMessages([]);
    }

    previousSelectedKeyRef.current = selectedKey;
  }, [selectedKey]);

  return {
    chatlist,
    setChatlist,
    selectedKey,
    setSelectKey,
    promptsOpen,
    setPromptsOpen,
    hasMore,
    setHasMore,
    current,
    setCurrent,
    fullScreen,
    setFullScreen,
    prompts,
    setPrompts,
    model,
    setModel,
    isMcpService,
    setIsMcpService,
    currentAccountTags,
    setCurrentAccountTags,
    unsendMessages,
    setUnsendMessages,
    promptConfig,
    setPromptConfig,
    open,
    setOpen,
    drawerWidth,
    setDrawerWidth,
    accountDialogConfig,
    setAccountDialogConfig,
    inputDisable,
    setInputDisable,
    searchPromptList,
    setSearchPromptList,
  };
}
